module.exports = __webpack_public_path__ + "img/list_slide_05.366ce9ec.jpg";